import {gql} from '@apollo/client'
import {ACAVerificationRecord} from '../queries/acaVerificationsQuery'

export interface ACAVerificationInput {
  policyId: number
  paymentStatus?: string
  paymentMethod?: string
  billingActionTaken?: string
  pendingDocuments?: string
  docsActionTaken?: string
  incomeModification?: string
  contactInfo?: string
  result?: string
  openTicketsDetail?: string
  additionalNotes?: string
}

interface ACAVerificationMutationResult {
  verification: ACAVerificationRecord | null
  success: boolean
  errors: Array<{field: string | null; message: string}> | null
}

export interface IResCreateACAVerification {
  createPolicyAcaVerification: ACAVerificationMutationResult
}

export interface IResUpdateACAVerification {
  updatePolicyAcaVerification: ACAVerificationMutationResult
}

const VERIFICATION_FIELDS = `
  id
  paymentStatus
  paymentMethod
  billingActionTaken
  pendingDocuments
  docsActionTaken
  incomeModification
  contactInfo
  result
  openTicketsDetail
  additionalNotes
  created
  updated
  createdBy { id firstName lastName }
  updatedBy { id firstName lastName }
`

export const CREATE_ACA_VERIFICATION = gql`
  mutation createPolicyAcaVerification($data: policy_aca_verification_input!) {
    createPolicyAcaVerification(data: $data) {
      verification {
        ${VERIFICATION_FIELDS}
      }
      success
      errors { field message }
    }
  }
`

export const UPDATE_ACA_VERIFICATION = gql`
  mutation updatePolicyAcaVerification($id: Int!, $data: policy_aca_verification_input!) {
    updatePolicyAcaVerification(id: $id, data: $data) {
      verification {
        ${VERIFICATION_FIELDS}
      }
      success
      errors { field message }
    }
  }
`
